import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
const useStyles = makeStyles((theme) => createStyles({
    root: {
        margin: theme.spacing(0.5, 0),
    },
}));
export const EntityChip = ({ onDelete, label, chipProps, ...props }) => {
    const classes = useStyles();
    return _jsx(Chip, { label: label, onDelete: onDelete, className: classes.root, ...chipProps, ...props });
};
//# sourceMappingURL=EntityChip.js.map